import React from 'react';
interface CountProps {
    text: string;
    count: number;
}
const Count = (props:CountProps) => {
    console.log(`Rendering ${props.text}`)
    return (
        <div>
            <h2>Inside Count: {props.text} -  { props.count}</h2>

        </div>
    );
};

export default React.memo(Count);
